import React from 'react';
import { Box, Typography } from '@mui/material';

const EditInvoicePage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Edit Invoice</Typography>
      <Typography variant="body1">Invoice editing functionality will be implemented here.</Typography>
    </Box>
  );
};

export default EditInvoicePage; 